import React, { useState, useEffect, useRef } from 'react';
import { MenuItem } from '@mui/material';
import Select from '@mui/material/Select';
import { fetchLogsApi, fetchLogsApionSearch } from '../../store/app/apis';
import { LOG_COLOR } from '../../constants';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { getTime } from '../../utils';
import styles from './logs.module.css';
import { TablePagination } from '@mui/material';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

export function Logs({ logtype, logsarray, logsarrayonsearch, isMobile, fetchLogsApi, fetchLogsApionSearch }) {
  const params = useParams();
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [anchorEl, setAnchorEl] = useState(null);
  const [level, setLevel] = useState(5);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [key, setKey] = useState('');
  const searchRef = useRef();
  let navigate = useNavigate();
  const handleChange = (event) => {
    setLevel(event.target.value);
  };
  const onChange = (searchTerm) => {
    setKey('');
    setPage(0);
  };
  const onSearch = (event) => {
    if (searchRef.current.value === '') {
      setKey('');
      return;
    }
    const value = searchRef.current.value;
    setKey(value);
    setPage(0);
  };
  const selectStyle = {
    color: '#55596F',
    borderRadius: '7px',
    height: '40px',
    backgroundColor: '#FFFFFF',
    '& #demo-simple-select': {
      height: '28px',
    },
  };
  const styling = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
    '& .MuiOutlinedInput-input': {
      padding: '6.5px',
    },
  };

  useEffect(() => {
    var payload = {};
    payload['size'] = rowsPerPage;
    payload['page'] = page + 1;

    if (level !== 5) {
      payload['level'] = level;
    }
    if (key !== '') {
      payload['search'] = key;
    }
    if (logtype === 'service') {
      payload[logtype] = params.id;
    } else {
      payload[logtype] = [params.id];
    }
    if (key !== '' || level !== 5) {
      fetchLogsApionSearch(payload).then((res) => {
        setCount(res);
      });
    } else {
      fetchLogsApi(payload).then((res) => {
        setCount(res);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, level, rowsPerPage, key]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const getServiceDetailPage = (event, id) => {
    event.preventDefault();
    navigate(`/dashboard/details/${id}`);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div className={styles.logs}>
      <div className={styles.log_bar}>
        <input type="text" ref={searchRef} onChange={onChange} placeholder="Search in Logs" />
        <button onClick={onSearch}>
          <SearchIcon />
        </button>
        <div className="levelbutton">
          <FormControl sx={styling}>
            <InputLabel id="demo-simple-select-label">Level</InputLabel>
            <Select
              sx={isMobile ? selectStyle : ''}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={level}
              label="level"
              onChange={handleChange}
            >
              <MenuItem value={1} onChange={handleChange}>
                Fatal
              </MenuItem>
              <MenuItem value={2} onChange={handleChange}>
                Error
              </MenuItem>
              <MenuItem value={3} onChange={handleChange}>
                Warn
              </MenuItem>
              <MenuItem value={4} onChange={handleChange}>
                Info
              </MenuItem>
              <MenuItem value={5} onChange={handleChange}>
                All
              </MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className={styles.logsbackground}>
        <table>
          <thead>
            <tr>
              {logtype === 'project' && <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Service</th>}
              <th>Time</th>
              <th style={{ textAlign: 'left', paddingLeft: '25px' }}>Logs</th>
            </tr>
          </thead>
          <tbody>
            {(key !== '' || level !== 5 ? logsarrayonsearch : logsarray)?.map((log) => (
              <tr>
                {logtype === 'project' && (
                  <td style={{ textAlign: 'left', paddingLeft: '25px' }}>
                    <a
                      href={`/dashboard/details/${log?.service}`}
                      onClick={(event) => {
                        getServiceDetailPage(event, log?.service);
                      }}
                      style={{ textDecoration: 'none' }}
                    >
                      {log?.sname}
                    </a>
                  </td>
                )}
                <td style={{ padding: '10px' }}>{getTime(log?.ct)}</td>
                <td
                  className={styles.paralog}
                  style={{ color: LOG_COLOR[log?.level], padding: '10px', textAlign: 'left', paddingLeft: '20px' }}
                >
                  {log?.msg}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 15, 25, 50, 100]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        count={count}
        page={page}
        sx={styling}
      />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    isMobile: state.app.isMobile,
    logsarray: state.app.logsarray,
    logsarrayonsearch: state.app.logsarrayonsearch,
  };
};
const mapDispatchToProps = {
  fetchLogsApi,
  fetchLogsApionSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
